module.exports = __webpack_public_path__ + "media/images/common/mail-d2f99cb916000550763f4c3c4a22dccb.png";